<template>
	<div
		:ref="setup._el"
		class="shared-paged-list-actions">
		<template v-if="use.includes('search')">
			<o-input
				v-show="setup.displayListSearchField"
				:ref="setup._listSearchField"
				v-model="setup.listFilterResearch"
				class="shared-paged-list-actions__search"
				clearable
				:label="$t('common.shared.actions.search')"
				@blur="setup.hideListSearchField()"
				@change="setup.refreshListAsync(true)"/>
			<o-icon
				v-tooltip="$t('common.shared.actions.search')"
				font-icon="icon-interface-search"
				@click="setup.showListSearchField()"/>
		</template>
		<o-icon
			v-if="use.includes('checkAll') && setup.isTouch"
			v-tooltip="setup.listService.listHasAllItemsSelected ? $t('common.shared.actions.deselectAll', { action: $t('common.label.deselect') }) : $t('common.shared.actions.selectAll', { action: $t('common.label.select') })"
			class="shared-paged-list-actions__checkAll"
			:class="{ 'text--success': setup.listService.listHasAllItemsSelected }"
			icon="check_all"
			@click="setup.listService.toggleSelectAllListItems()"/>
		<o-icon
			v-if="use.includes('filter')"
			v-tooltip="$t('common.shared.actions.filter')"
			font-icon="icon-interface-text-formatting-filter-1"
			:marker="setup.listService.listHasActiveFilter"
			marker-color="info"
			@marker-click="setup.filterService.resetAndApplyAsync()"
			@click="setup.filterService.showFilterAside()"/>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedPagedListActionsEmits, SharedPagedListActionsProps } from './SharedPagedListActionsSetup';
import SharedPagedListActionsSetup from './SharedPagedListActionsSetup';
const emits = defineEmits<SharedPagedListActionsEmits>() as SharedPagedListActionsEmits;
const props = withDefaults(defineProps<SharedPagedListActionsProps>(), SharedPagedListActionsSetup.defaultProps);
const setup = new SharedPagedListActionsSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
.shared-paged-list-actions {
	display: flex;
	gap: 1rem;
	align-items: center;
	min-height: 2.5rem;

	:deep(.orion-icon) {
		font-size: 1rem;
	}

	&__search {
		margin: 0;
	}

	#left-aside > & {
		.shared-paged-list-actions__search {
			display: block !important;
			order: 9;
			width: 100%;

			+ .orion-icon.icon-interface-search {
				display: none;
			}
		}

		.icon-interface-text-formatting-filter-1 {
			display: none;
		}
	}
}
</style>
